module.exports = __webpack_public_path__ + "static/img/bg.913fad9.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/bg.png
// module id = eEKC
// module chunks = 4